import { Diamond } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative border-t border-border/40 bg-muted/20" data-testid="landing-footer">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2.5 mb-4">
              <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 text-primary">
                <Diamond className="w-4 h-4" />
              </div>
              <span className="font-bold text-lg tracking-tight text-foreground">Aretê</span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm">
              Organize suas receitas, despesas, metas e investimentos em um só lugar. Inteligência financeira para o seu dia a dia.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-4">
              Produto
            </h4>
            <ul className="space-y-3">
              {['Dashboard', 'Transações', 'Metas', 'Investimentos', 'Relatórios'].map((item) => (
                <li key={item}>
                  <span className="text-sm text-muted-foreground hover:text-foreground transition-colors cursor-default">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-4">
              Conta
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Entrar', to: '/login' },
                { label: 'Cadastrar', to: '/login' },
                { label: 'Termos', to: '/termos' },
                { label: 'Privacidade', to: '/privacidade' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Aretê. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacidade" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Privacidade
            </Link>
            <Link to="/termos" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Termos
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
